import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CapturePageService {

  showMoreInfo = new EventEmitter();

  constructor() { }
}
